export default __webpack_public_path__ + "static/media/grapgh-not.f6707cba.png";